import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

type Props = {
  loading?: boolean;
  children?: any;
};

export default function Spin({ loading, children }: Props) {
  return (
    <div className={`spin-component`}>
      <div className={loading ? 'on-loading' : ''}>{children}</div>
      <AnimatePresence>
        {loading ? (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
            <div className="overlay" />
            <div className="loading-icon">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only"></span>
              </div>
            </div>
          </motion.div>
        ) : null}
      </AnimatePresence>
    </div>
  );
}
